import { Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import { PATH_MANAGEMENT } from 'src/routes/paths';
import TaxOfficeReportManagement from 'src/sections/@dashboard/managements/taxes-report/TaxOfficeReportManagement';

const TaxOfficeReport = () => {
    const { themeStretch } = useSettings();

  return (
    <>
      <Page title="گزارش اداره مالیات">
              <Container maxWidth={themeStretch ? false : "lg"}>

          <HeaderBreadcrumbs
            heading={'گزارش اداره مالیات'}
            links={[
              {
                name: 'مدیریت',
                href: PATH_MANAGEMENT.management.root,
              },

              { name: 'گزارش اداره مالیات'},
            ]}
          />
          <TaxOfficeReportManagement />
    </Container>
      </Page>
    </>
  );
};

export default TaxOfficeReport;
